// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsClsInboundAddress {
    'address1'?: string | null;
    'address2'?: string | null;
    'addressType'?: string | null;
    'country'?: string | null;
    'zipCode'?: string | null;
    'city'?: string | null;
    'state'?: string | null;
    'primary'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsClsInboundAddress>> = [
        {
            "name":     "address1",
            "baseName": "address1",
            "type":     "string"
        },
        {
            "name":     "address2",
            "baseName": "address2",
            "type":     "string"
        },
        {
            "name":     "addressType",
            "baseName": "addressType",
            "type":     "string"
        },
        {
            "name":     "country",
            "baseName": "country",
            "type":     "string"
        },
        {
            "name":     "zipCode",
            "baseName": "zipCode",
            "type":     "string"
        },
        {
            "name":     "city",
            "baseName": "city",
            "type":     "string"
        },
        {
            "name":     "state",
            "baseName": "state",
            "type":     "string"
        },
        {
            "name":     "primary",
            "baseName": "primary",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsClsInboundAddress.attributeTypeMap;
    }
}
